import chatManagement from '@sv-support-sdk/chat-api/modules/chatManagement';
import messages from '@sv-support-sdk/chat-api/modules/messages';
import ticket from '@sv-support-sdk/chat-api/modules/ticket';
import userProfile from '@sv-support-sdk/chat-api/modules/userProfile';
import screenSharing from '@sv-support-sdk/chat-api/modules/screenSharing';
import chatStatus from '@sv-support-sdk/chat-api/modules/chatStatus';

import customerEffortScore from './modules/customerEffortScore';

import instance, { supportBackendInstance } from './instance';

export default {
  customerEffortScore: customerEffortScore(supportBackendInstance),
  chatManagement: chatManagement(instance),
  messages: messages(instance),
  userProfile: userProfile(instance),
  ticket: ticket(supportBackendInstance),
  screenSharing: screenSharing(instance),
  chatStatus: chatStatus(instance, supportBackendInstance),
};
